import React from "react";

import { Container, Text } from "./TextAuxiliary.styles";

interface TextAuxiliaryProps {
  text: string;
  isValid: boolean;
  disabled?: boolean;
}

export const TextAuxiliary: React.FC<TextAuxiliaryProps> = ({
  text,
  isValid,
  disabled = false,
}) => {
  return (
    <Container>
      <Text {...{ isValid, isIcon: true, disabled }}>
        {!isValid ? "\u2022 " : "✓"}
      </Text>
      <Text {...{ isValid, disabled }}>{text}</Text>
    </Container>
  );
};
